module.exports = __webpack_public_path__ + "static/media/img-7.cc15d34f.jpg";